import { render, staticRenderFns } from "./import-client-modal.vue?vue&type=template&id=1e5311de"
import script from "./import-client-modal.vue?vue&type=script&lang=js"
export * from "./import-client-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports